import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Download, FileText } from "lucide-react";
import Navbar from "../Components/Navbar";
import "../Styles/Vacancies.css";
import { useLanguage } from "../i18n/LanguageContext";
import ClinicPurpose from "../Components/ClinicPurpose";
function AboutDetail() {
  const { t } = useLanguage();
  const { section } = useParams();
  const page = t.aboutPages[section];
  const [documentText, setDocumentText] = useState("");

  useEffect(() => {
    if (!page?.textFile) return;
    fetch(`${process.env.PUBLIC_URL}${page.textFile}`)
      .then((response) => response.text())
      .then(setDocumentText)
      .catch(() => setDocumentText("Не удалось загрузить документ."));
  }, [page]);

  if (!page) return <Navigate to="/" replace />;
  if (section === "mission" || section === "vision") return <ClinicPurpose section={section} />;

  const paragraphs = documentText.split(/\r?\n\s*\r?\n/).filter(Boolean);
  return <><Navbar /><main className={`about-detail ${page.textFile ? "ethical-code-page" : ""} ${Array.isArray(page.text) ? "director-message" : ""} ${page.tasks ? "compliance-page" : ""}`}><p>{page.eyebrow}</p><h1>{page.title}</h1><div>{page.textFile ? paragraphs.map((paragraph, index) => {
    const text = paragraph.trim();
    const lines = text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
    const isHeading = /^(Кодекс деловой этики клиники «НАРАМЕД»|Миссия Кодекса|\d+(?:\.\d+)*\.?\s+[^.]+)$/i.test(text) && text.length < 120;
    const isBulletList = lines.length > 1 && lines.every((line) => line.startsWith("• "));
    const isNumberedList = lines.length > 1 && lines.every((line) => /^\d+\)\s/.test(line));
    if (isHeading) return <h2 key={index}>{text}</h2>;
    if (isBulletList) return <ul className="ethical-code-list" key={index}>{lines.map((line) => <li key={line}>{line.slice(2)}</li>)}</ul>;
    if (isNumberedList) return <ol className="ethical-code-list" key={index}>{lines.map((line) => <li key={line}>{line.replace(/^\d+\)\s*/, "")}</li>)}</ol>;
    return <p key={index}>{text}</p>;
  }) : page.tasks ? <>
    <p>{page.text}</p>
    <h2>{page.tasksTitle}</h2>
    <ul>{page.tasks.map((task) => <li key={task}>{task}</li>)}</ul>
    <section className="compliance-documents">
      <h2>{page.documentsTitle}</h2>
      <div>{page.documents.map((document) => {
        const url = `${process.env.PUBLIC_URL}${document.file}`;
        return <a href={url} download key={document.file}>
          <span><FileText aria-hidden="true" /><strong>{document.title}</strong></span>
          <Download aria-hidden="true" />
        </a>;
      })}</div>
    </section>
  </> : Array.isArray(page.text) ? page.text.map((paragraph, index) => <p key={index}>{paragraph}</p>) : <p>{page.text}</p>}</div></main></>;
}
export default AboutDetail;
